import { Texts, Media, Button } from "../Object";
import { Space, List } from "../Layout";
import { Link } from "react-router-dom";

const Banner = (props) => {
  return(
    <>
      <div className="c-grid__repeat--3">
        <List Item={Item} length={3}></List>
      </div>
    </>
  )
};

export const Item = (props) => {
  const link = [
    '/voice/',
    '/fix/',
    '/company/'
  ];
  return(
    <>
      <Link className="c-button__banner p-box__items--banner" to={link[props.index]}>
        <Media class="p-img__banner-link" src={`banner/back-list${props.index}`} alt="link"></Media>
        <div className="p-box__items--banner__texts">
          <Texts slug={`banner/list-title${props.index}`} class="c-text--en c-text--big c-text--gray c-text--center"></Texts>
          <Space size={['32px 0 0', '24px 0 0']}>
            <Texts slug={`banner/list-body${props.index}`} class="c-text--bold c-text--white c-text--center"></Texts>
          </Space>
        </div>
      </Link>
    </>
  )
}

export default Banner;
